module.exports = __webpack_public_path__ + "img/thankyou_hero.359af925.jpg";